module.exports = __webpack_public_path__ + "static/media/sence1.0ec5a10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/sence1.png
// module id = 531
// module chunks = 0